module.exports = __webpack_public_path__ + "static/media/youtube.fae44906.svg";